<!-- eslint-disable vue/valid-v-slot -->
<template>
  <div class="uploader-templates-page">
    <div class="page-header">
      <div class="page-header-text">
        <h1 class="page-title">Szablony importu</h1>
      </div>
    </div>
    <v-card outlined class="rounded-lg content-card" style="overflow: hidden;">
      <v-data-table
        :headers="headersForTable"
        :items="mathEqs"
        class="elevation-0"
        :loading="loading"
      >
        <template v-slot:top>
          <div class="table-section-title">
            <div class="filter-icon"><v-icon size="18" color="#5478FF">mdi-math-integral</v-icon></div>
            <div class="filter-title">{{ $t('uploaderTemplates.title') }}</div>
            <v-spacer></v-spacer>
            <button class="action-pill action-pill--primary" @click="openModal()">
              <v-icon left small>mdi-plus</v-icon>
              {{ $t('common.add') }}
            </button>
            <button class="action-pill action-pill--secondary ml-2" @click="exportMathEqs()">
              <v-icon left small>mdi-download</v-icon>
              {{ $t('common.download') }}
            </button>
          </div>
        </template>

            <template v-slot:item.delete="{ item }">
              <v-btn class="error" @click="deleteMath(item.id)"
                ><v-icon small class="pt-1">mdi-delete</v-icon></v-btn
              >
            </template>
          </v-data-table>
          </v-card>

      <!-- Modal -->
      <v-dialog content-class="dark-form-dialog" v-model="modal">
        <v-card>
          <v-card-title class="headline"
            >{{ $t('uploaderTemplates.addFileCreateTemplate') }}</v-card-title
          >

          <v-card-text>
            <v-form ref="form">
              <!-- Step 1: File Upload -->
              <v-row>
                <v-col cols="12">
                  <v-select
                    v-model="provider"
                    :items="providers"
                    item-text="name"
                    item-value="id"
                    label="Dotyczy"
                    :rules="[rules.required]"
                    required
                  />
                </v-col>
                <v-col cols="12">
                  <v-file-input
                    label="Plik"
                    accept=".csv, .xlsx"
                    v-model="file"
                    @change="handleFileUpload"
                  ></v-file-input>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    label="Nazwa"
                    v-model="name"
                    hint="Nazwa"
                    persistent-hint
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    label="Wzór"
                    v-model="customEquation"
                    hint="Use headers and custom numbers as variables"
                    persistent-hint
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    label="Pole z Gotówką"
                    v-model="cashField"
                    hint="w pliku"
                    persistent-hint
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    label="Pole z Brutto"
                    v-model="bruttoField"
                    hint="w pliku"
                    persistent-hint
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    label="Pole z Netto"
                    v-model="nettoField"
                    hint="w pliku"
                    persistent-hint
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    label="Pole z id kierowcy"
                    v-model="idField"
                    hint="w pliku"
                    persistent-hint
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    label="Pole z bonusem / questem"
                    v-model="bonusField"
                    hint="Bolt: kampanie, Uber: quest, FreeNow: bonus — tylko podgląd (wartość + 15%), nie wpływa na rozliczenie"
                    persistent-hint
                  ></v-text-field>
                </v-col>
                <!-- Cooperation Type -->
                <v-col cols="12" md="6">
                  <v-select
                    v-model="cooperationType"
                    :items="cooperationTypes"
                    label="Wzór dotyczy rozliczeń:"
                    :rules="[rules.required]"
                    required
                  />
                </v-col>
                <v-col cols="12">
                  <div>
                    <v-chip
                      v-for="header in headers"
                      :key="header"
                      class="ma-1"
                      outlined
                      color="primary"
                      text-color="black"
                      @click="insertHeaderToEquation(header)"
                    >
                      {{ header }}
                    </v-chip>
                  </div>
                </v-col>
              </v-row>

              <!-- Step 3: Dynamic Custom Numbers -->
              <v-row>
                <v-col cols="12">
                  <h3>{{ $t('uploaderTemplates.customVariables') }}</h3>
                </v-col>
                <v-col
                  v-for="(customNumber, index) in customNumbers"
                  :key="index"
                  cols="12"
                  md="6"
                  lg="4"
                  class="d-flex align-center"
                >
                  <v-text-field
                    v-model="customNumber.label"
                    label="Nazwa"
                    placeholder="e.g., stawka_vat"
                    outlined
                    dense
                    @input="validateVariableName(index)"
                  ></v-text-field>
                  <v-text-field
                    v-model="customNumber.value"
                    label="Wartość"
                    placeholder="Wpisz wartość"
                    type="number"
                    outlined
                    dense
                  ></v-text-field>
                  <v-btn icon @click="removeCustomNumber(index)">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="12">
                  <v-btn
                    text
                    color="primary"
                    @click="addCustomNumber"
                    small
                    class="mt-2"
                  >
                    {{ $t('uploaderTemplates.addCustomVariable') }}
                  </v-btn>
                </v-col>
              </v-row>

              <!-- Step 4: Preview Table -->
              <v-row class="mt-4">
                <v-col cols="12">
                  <v-data-table
                    :headers="tableHeadersWithResult"
                    :items="tableDataWithResults"
                    dense
                    outlined
                  >
                    <template v-slot:top>
                      <v-toolbar flat>
                        <v-toolbar-title>{{ $t('common.preview') }}</v-toolbar-title>
                      </v-toolbar>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="secondary" @click="modal = false">{{ $t('common.cancel') }}</v-btn>
            <v-btn color="primary" @click="submitFile">{{ $t('common.save') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </div>
</template>

<script>
import Papa from "papaparse";
import * as XLSX from "xlsx";
import Swal from "sweetalert2";
const axios = require("axios");
export default {
  data() {
    return {
      mathEqs: [],
      headersForTable: [
        {
          text: "Typ",
          align: "start",
          sortable: false,
          value: "type",
        },
        {
          text: "Nazwa",
          align: "start",
          sortable: false,
          value: "name",
        },
        {
          text: "Wzór",
          align: "start",
          sortable: false,
          value: "equations",
        },
        {
          text: "Pole z Gotówka",
          align: "start",
          sortable: false,
          value: "cashField",
        },
        {
          text: "Pole z Brutto",
          align: "start",
          sortable: false,
          value: "bruttoField",
        },
        {
          text: "Pole z Netto",
          align: "start",
          sortable: false,
          value: "nettoField",
        },
        {
          text: "Pole z ID",
          align: "start",
          sortable: false,
          value: "idField",
        },
        {
          text: "Sposób rozliczenia",
          align: "start",
          sortable: false,
          value: "cooperationType",
        },
        { text: "", value: "delete", sortable: false },
      ],
      modal: false,
      file: null,
      headers: [],
      tableHeadersWithResult: [],
      tableData: [],
      customEquation: "",
      headerMap: {}, // Map for original headers to normalized headers
      customNumbers: [],
      provider: null,
      cooperationType: null,
        cooperationTypes: [
        "B2B_VAT",
        "B2B_NO_VAT",
        "FIFTY_FIFTY",
        "CONNECTION",
      ],
      providers: [
        {
          name: "BOLT",
          id: "BOLT",
        },
        {
          name: "UBER",
          id: "UBER",
        },
        {
          name: "FREENOW",
          id: "FREENOW",
        },
      ],
      cashField: null,
      bruttoField: null,
      nettoField: null,
      name: null,
      idField: null,
      bonusField: null,
      rules: {
        required: (value) => !!value || "Wymagane.",
      },
    };
  },
  computed: {
    tableDataWithResults() {
      return this.tableData.map((row) => {
        try {
          const result = this.evaluateEquation(row);
          return { ...row, result };
        } catch (error) {
          return { ...row, result: "Error" };
        }
      });
    },
  },
  async created() {
    await this.initialize();
  },
  methods: {
    async toggleLoading(type) {
      const toggle = type;
      localStorage.setItem("loading", toggle);
      window.dispatchEvent(
        new CustomEvent("toggleLoading", {
          detail: {
            loading: localStorage.getItem("loading"),
            overlay: localStorage.getItem("loading"),
          },
        })
      );
    },
    exportMathEqs() {
      const data = this.mathEqs.map(eq => ({
        name: eq.name,
        type: eq.type,
        equations: eq.equations,
        cooperationType: eq.cooperationType,
        cashField: eq.cashField,
        bruttoField: eq.bruttoField,
        nettoField: eq.nettoField,
        idField: eq.idField,
        bonusField: eq.bonusField,
      }));
      const json = JSON.stringify(data, null, 2);
      const blob = new Blob([json], { type: "application/json" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "wzory-export.json";
      a.click();
      window.URL.revokeObjectURL(url);
    },
    async deleteMath(id) {
      Swal.fire({
        title: "Napewno usunąć?",
        text: "",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Tak",
        cancelButtonText: "Anuluj",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await axios({
              method: "delete",
              url: process.env.VUE_APP_ROOT_API + "import/math/" + id,
              headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
              },
            });
            await this.initialize();
          } catch (e) {
            console.log(e);
            Swal.fire("Błąd", e.response.data.message.toString(), "error");
          }
        }
      });
    },
    async initialize() {
      this.loading = true;
      try {
        const mathEqs = await axios({
          method: "get",
          url: process.env.VUE_APP_ROOT_API + `import/math`,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        });
        this.mathEqs = mathEqs.data.data.map((user) => {
          return {
            equations: user.equationStr,
            type: user.type,
            id: user.id,
            name: user.name,
            cooperationType: user.cooperationType,
            cashField: user.cashField,
            bruttoField: user.bruttoField,
            nettoField: user.nettoField,
            idField: user.idField,
            bonusField: user.bonusField,
          };
        });
      } catch (e) {
        console.log(e);
        Swal.fire("Błąd", e.response.data.message.toString(), "error");
      }
      this.loading = false;
    },
    openModal() {
      this.modal = true;
    },
    handleFileUpload() {
      if (!this.file) return;

      const reader = new FileReader();
      const fileExt = this.file.name.split(".").pop();

      if (fileExt === "csv") {
        reader.onload = (e) => {
          const data = Papa.parse(e.target.result, { header: true });
          this.processData(data.data);
        };
        reader.readAsText(this.file);
      } else if (fileExt === "xlsx") {
        reader.onload = (e) => {
          const workbook = XLSX.read(e.target.result, { type: "binary" });
          const sheetName = workbook.SheetNames[0];
          const sheetData = XLSX.utils.sheet_to_json(
            workbook.Sheets[sheetName]
          );
          this.processData(sheetData);
        };
        reader.readAsBinaryString(this.file);
      } else {
        alert("Nieprawidłowy typ pliku");
      }
    },
    normalizeHeader(header) {
      return header
        .trim()
        .replace(/\s+/g, "_")
        .replace(/[^a-zA-Z0-9_]/g, "");
    },
    processData(data) {
      if (!data || data.length === 0) return;
      data = data.filter((it) => Object.keys(it).length > 2);
      this.headerMap = {};
      const normalizedHeaders = Object.keys(data[0]).map((header) => {
        const normalized = this.normalizeHeader(header);
        this.headerMap[header] = normalized;
        return normalized;
      });

      this.headers = normalizedHeaders;
      this.tableHeadersWithResult = [
        ...this.headers.map((header) => ({ text: header, value: header })),
        { text: "Result", value: "result" },
      ];

      this.tableData = data.map((row) =>
        Object.keys(row).reduce((acc, key) => {
          const normalizedKey = this.headerMap[key];
          acc[normalizedKey] = row[key];
          return acc;
        }, {})
      );
    },
    insertHeaderToEquation(header) {
      this.customEquation += header;
    },
    evaluateEquation(row) {
      const equation = this.customEquation;

      const rowVariables = this.headers.reduce((vars, header) => {
        vars[header] = parseFloat(row[header]) || 0;
        return vars;
      }, {});

      const customVars = this.customNumbers.reduce((vars, num) => {
        vars[num.label] = parseFloat(num.value) || 0;
        return vars;
      }, {});

      const allVars = { ...rowVariables, ...customVars };

      const equationFunction = new Function(
        ...Object.keys(allVars),
        `return ${equation};`
      );

      return equationFunction(...Object.values(allVars));
    },
    addCustomNumber() {
      this.customNumbers.push({
        label: `customNum${this.customNumbers.length + 1}`,
        value: 0,
      });
    },
    removeCustomNumber(index) {
      this.customNumbers.splice(index, 1);
    },
    validateVariableName(index) {
      const currentName = this.customNumbers[index].label;
      this.customNumbers[index].label = this.normalizeHeader(currentName);
    },
    async submitFile() {
      console.log("File Submitted", {
        type: this.provider,
        equationStr: this.customEquation,
        customNumbers: JSON.stringify(this.customNumbers),
      });
      try {
        await this.toggleLoading(true);
        await axios({
          method: "post",
          url: process.env.VUE_APP_ROOT_API + "import/math",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
          data: {
            type: this.provider,
            equationStr: this.customEquation,
            customNumbers: JSON.stringify(this.customNumbers),
            cashField: this.cashField,
            bruttoField: this.bruttoField,
            nettoField: this.nettoField,
            name: this.name,
            cooperationType: this.cooperationType,
            idField: this.idField,
            bonusField: this.bonusField,
          },
        });
        this.modal = false;
        await this.toggleLoading(false);
        await this.initialize();
      } catch (e) {
        await this.toggleLoading(false);
        console.log(e);
        Swal.fire("Błąd", e.response.data.message.toString(), "error");
      }
    },
  },
};
</script>

<style scoped>
.v-chip {
  cursor: pointer;
}
.uploader-templates-page {
  margin: -24px;
  padding: 24px;
  background: #181C28;
  min-height: calc(100vh - 64px);
  color: #E6EAF2;
}
.page-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 20px;
}
.page-eyebrow {
  font-size: 11px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #5478FF;
  font-weight: 600;
}
.page-title {
  font-size: 28px;
  font-weight: 700;
  margin: 4px 0 0 0;
  color: #FFFFFF;
}
.content-card {
  background: #232838 !important;
  color: #E6EAF2 !important;
  border-color: #2A3142 !important;
}
.table-section-title {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px 20px;
  border-bottom: 1px solid #2A3142;
}
.filter-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: rgba(84, 120, 255, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
}
.filter-title {
  font-size: 15px;
  font-weight: 600;
  color: #E6EAF2;
}
.action-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 600;
  border: 1px solid transparent;
  cursor: pointer;
  transition: all 0.15s ease;
}
.action-pill--primary { background: #5478FF; color: #FFFFFF; }
.action-pill--primary:hover { background: #3F62E8; }
.action-pill--secondary {
  background: rgba(148, 160, 184, 0.15);
  color: #E6EAF2;
  border-color: #2A3142;
}
.action-pill--secondary:hover { background: rgba(148, 160, 184, 0.25); }
.uploader-templates-page >>> .v-data-table {
  background: #232838 !important;
  color: #E6EAF2 !important;
}
.uploader-templates-page >>> .v-data-table thead tr th {
  background: #1F2433 !important;
  color: #94A0B8 !important;
  border-bottom: 1px solid #2A3142 !important;
}
.uploader-templates-page >>> .v-data-table tbody tr td {
  border-bottom: 1px solid #2A3142 !important;
  color: #E6EAF2 !important;
}
.uploader-templates-page >>> .v-data-table tbody tr:hover {
  background: rgba(84, 120, 255, 0.06) !important;
}
.uploader-templates-page >>> .v-text-field--outlined fieldset {
  border-color: #2A3142 !important;
}
.uploader-templates-page >>> .v-text-field input,
.uploader-templates-page >>> .v-select__selection {
  color: #E6EAF2 !important;
}
.uploader-templates-page >>> .v-label {
  color: #94A0B8 !important;
}
.uploader-templates-page >>> .v-dialog .v-card {
  background: #232838 !important;
  color: #E6EAF2 !important;
}
.uploader-templates-page >>> .v-card__title,
.uploader-templates-page >>> .v-card__text {
  color: #E6EAF2 !important;
}
</style>
